import styled from 'styled-components';
import { getBrightInvertedColor } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../../../../meta';
import { getLayoutObjFromName } from '../../../../helpers';

export const ArrowOne = ({ rotate }) => {
  const { sliderElementsColor, layout } = useSettings();
  const { name } = getLayoutObjFromName(layout);

  return (
    <Container>
      <Icon
        $rotate={rotate}
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill={
            name === 'slider'
              ? getBrightInvertedColor(sliderElementsColor, [
                  'rgb(255, 255, 255)',
                  'rgb(29, 33, 41)'
                ])
              : undefined
          }
          d="M19.643 16L9.286 26.336a.973.973 0 0 0 0 1.379c.381.38 1 .38 1.38 0l11.048-11.026a.973.973 0 0 0 0-1.378L10.667 4.285a.978.978 0 0 0-1.381 0 .973.973 0 0 0 0 1.379L19.643 16z"
        />
      </Icon>
    </Container>
  );
};

const Container = styled.div.attrs({
  className: `${meta.stylePrefix}-arrow-component`
})`
  display: flex;
  position: relative;

  .eas-navigation-next & {
    right: 8px;
  }

  .eas-navigation-previous & {
    left: 8px;
  }
`;

const Icon = styled.svg.attrs({
  className: `${meta.stylePrefix}-arrow-icon`
})`
  z-index: 3;
  position: relative;
  transition: 0.3s ease all;
  opacity: 1;

  ${({ $rotate }) => $rotate && `transform: rotateZ(-180deg);`}

  .eas-navigation-previous & {
    left: 0;
  }

  .eas-navigation-previous:hover & {
    left: -4px;
  }

  .eas-navigation-next & {
    right: 0;
  }

  .eas-navigation-next:hover & {
    right: -4px;
  }
`;
